export default "__VITE_ASSET__D0ujocXm__"